import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5c709a9f"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "article__item-header" };
import CoreService from "../services/core.service";
import { Views } from "@/types/ConfigTypes";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ArticleItem',
    props: {
        id: {
            type: Number,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        body: {
            type: String,
            required: true
        }
    },
    setup(__props) {
        const props = __props;
        const articleClicked = () => {
            CoreService.push(Views.ARTICLE, { id: props.id, title: props.title });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "article__item messenger__selection--hover cursor-pointer",
                onClick: articleClicked
            }, [
                _createElementVNode("span", _hoisted_1, _toDisplayString(__props.title), 1),
                _createElementVNode("div", null, _toDisplayString(__props.body), 1)
            ]));
        };
    }
});
